import React from "react";
import "./style.scss";

const Statistics = (props) => {
  const { data } = props;
  const items = data.map((datum) => {
    return <StatisticsCard {...datum} />;
  });
  return <div className="statistics-component">{items}</div>;
};

export default Statistics;

function StatisticsCard({ value, name }) {
  return (
    <div className="statistics-card">
      <div className="value">{value}</div>
      <div className="name">{name}</div>
    </div>
  );
}
